module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/rainbow-reader.aba2056017c7c71ba2e42361a4314fcc.svg";